'use strict';

$ = jQuery;

/**
 * Cliques em veja também
 */
$(".jc-post-veja-tambem a:not(.jc-post-veja-tambem-category)").on('click', function () {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post',
    'eventAction': 'Clique - Veja Também',
    'eventLabel': $(this).parents('.jc-post-veja-tambem').find('.jc-post-veja-tambem-title').text()
  });

  gtag('event', 'Post', {
    'eventAction': 'Clique - Veja Também',
    'eventLabel': $(this).parents('.jc-post-veja-tambem').find('.jc-post-veja-tambem-title').text()
  });
});